import { MissingSearchParameterError } from './errors';

/**
 * @deprecated
 */
export const searchParams = () => new URLSearchParams(window.location.search);

/**
 * @deprecated
 */
export const searchParam = (key: string) => searchParams().get(key);

/**
 * @deprecated
 */
export const requireSearchParam = (key: string) => {
  const value = searchParam(key);
  if (!value) throw new MissingSearchParameterError(key);
  return value;
};

/**
 * @deprecated
 */
export const buildSearchParamsUrl = (
  url: string,
  params: Record<string, any>
) => `${url}?${new URLSearchParams(params).toString()}`;
